import axiosInstance from '@/store/axios'
import { rejectError } from '@/store/helper'

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // eslint-disable-next-line no-unused-vars
    assets ({ commit }, params) {
      return axiosInstance.get('/api/v1/assets', { params })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    getAssetById ({ commit, state }, params) {
      // eslint-disable-next-line consistent-return
      return axiosInstance.get(`/api/v1/assets/${params.id}`, { params })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    assetCount ({ commit }, params) {
      return axiosInstance.get('/api/v1/assets/$count', { params })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    updateAsset ({ dispatch }, asset) {
      return axiosInstance({
        method: 'PATCH',
        url: `/api/v1/assets/${asset.id}`,
        data: asset,
      })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
  },
}
